const APP_STORE_URL = "https://apple.co/4hflsio";

export const ComingSoonButton = ({ testId }) => (
  <a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="inline-block transition-[transform,filter] duration-300 hover:-translate-y-0.5 hover:brightness-110"
  >
    <img
      src="/assets/app-store-badge.png"
      alt="Download on the App Store"
      className="h-[52px] w-auto rounded-[10px] shadow-[0_18px_40px_-16px_rgba(11,19,32,0.45)]"
    />
  </a>
);
